import React, { useState } from 'react';
import classNames from 'classnames/bind';
import { Alphabet } from 'sections/Resources/FreightDictionary/data';
import { Tag } from 'sections/Resources/FreightDictionary/components/SectionTerms/SearchPanel/SearchTags/Tag';
import styles from 'sections/Resources/FreightDictionary/components/SectionTerms/SearchPanel/SearchTags/SearchTags.module.scss';

const cn = classNames.bind(styles);

const SearchTags = () => {
  const [activeTagIdx, setActiveTagIdx] = useState<number>(0);

  const tagsElements = Alphabet.map((item: string, idx: number) => {
    return (
      <Tag
        key={item}
        tagText={item}
        isActive={activeTagIdx === idx}
        onTagClick={() => setActiveTagIdx(idx)}
      />
    )
  });

  return (
    <div className={cn('search-tags')}>
      <div className={cn('search-tags__list')}>
        {tagsElements}
      </div>
    </div>
  );
};

export { SearchTags };